import * as ambassadorWixEmailMarketingV1AccountDetails from './email-marketing-v1-account-details-account-details.http.js';
import * as ambassadorWixEmailMarketingV1AccountDetailsTypes from './email-marketing-v1-account-details-account-details.types.js';
import * as ambassadorWixEmailMarketingV1AccountDetailsUniversalTypes from './email-marketing-v1-account-details-account-details.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAccountDetails(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEmailMarketingV1AccountDetailsUniversalTypes.GetAccountDetailsRequest,
  ambassadorWixEmailMarketingV1AccountDetailsTypes.GetAccountDetailsRequest,
  ambassadorWixEmailMarketingV1AccountDetailsUniversalTypes.GetAccountDetailsResponse,
  ambassadorWixEmailMarketingV1AccountDetailsTypes.GetAccountDetailsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1AccountDetails.get(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/account-details',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AccountDetails as AccountDetailsOriginal,
  Enum as EnumOriginal,
  EnumWithLiterals as EnumWithLiteralsOriginal,
  Package as PackageOriginal,
  Quota as QuotaOriginal,
  BillingCycle as BillingCycleOriginal,
  BillingCycleWithLiterals as BillingCycleWithLiteralsOriginal,
  QuotaPeriod as QuotaPeriodOriginal,
  Features as FeaturesOriginal,
  Rank as RankOriginal,
  RankWithLiterals as RankWithLiteralsOriginal,
  GetAccountDetailsRequest as GetAccountDetailsRequestOriginal,
  GetAccountDetailsResponse as GetAccountDetailsResponseOriginal,
  GetComplianceDetailsRequest as GetComplianceDetailsRequestOriginal,
  GetComplianceDetailsResponse as GetComplianceDetailsResponseOriginal,
  ComplianceDetails as ComplianceDetailsOriginal,
  ComplianceDetailsProductOptionsOneOf as ComplianceDetailsProductOptionsOneOfOriginal,
  Product as ProductOriginal,
  ProductWithLiterals as ProductWithLiteralsOriginal,
  EmailMarketingOptions as EmailMarketingOptionsOriginal,
  AutomationOptions as AutomationOptionsOriginal,
  RestrictionReason as RestrictionReasonOriginal,
  RestrictionReasonTypeOneOf as RestrictionReasonTypeOneOfOriginal,
  Content as ContentOriginal,
  ContentWithLiterals as ContentWithLiteralsOriginal,
  SenderReputation as SenderReputationOriginal,
  SenderReputationWithLiterals as SenderReputationWithLiteralsOriginal,
  Statistics as StatisticsOriginal,
  StatisticsWithLiterals as StatisticsWithLiteralsOriginal,
  RespondRequest as RespondRequestOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  SupportTicketData as SupportTicketDataOriginal,
  RespondResponse as RespondResponseOriginal,
} from './email-marketing-v1-account-details-account-details.types.js';
